import React, { useState } from 'react';
import { InputAdornment } from '@mui/material';
import { ArcButton, ArcStack, ArcTabPanel, ArcOutlinedInput } from '@src/core/ui';
import { SectionWrapper, DroneHeader, DroneList, PanelWrapper } from './components';
import { ArcBaseContent, ArcBaseSidebar } from '@src/core/components';
import { MaintenancePanel, OrderHistoryPanel } from './panel';
import { DronesPageProps } from './types';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SearchIcon } from '@src/assets/icons/search.svg';
import { ReactComponent as CloseIcon } from '@src/assets/icons/close.svg';

const DronesPage: React.FC<DronesPageProps> = () => {
  const navigate = useNavigate();
  const [searchName, setSearchName] = useState('');

  return (
    <ArcStack direction='row'>
      <ArcBaseSidebar>
        <ArcStack spacing={2} sx={{ height: '100%', minHeight: 0 }}>
          <ArcButton.brand size='large' onClick={() => navigate('add-drone')}>
            Add drone
          </ArcButton.brand>

          <ArcOutlinedInput
            placeholder="Search"
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
            size="small"
            fullWidth
            autoComplete="off"
            sx={{
              '& .MuiInputBase-input': { color: 'white' },
              '& .MuiInputBase-input::placeholder': { color: 'text.secondary', opacity: 1 },
            }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start" sx={{ color: 'text.secondary' }}>
                    <SearchIcon style={{ width: 16, height: 16 }} />
                  </InputAdornment>
                ),
                endAdornment: searchName ? (
                  <InputAdornment position="end" sx={{ color: 'text.secondary' }}>
                    <CloseIcon
                      style={{ width: 16, height: 16, cursor: 'pointer' }}
                      onClick={() => setSearchName('')}
                      role="button"
                      aria-label="Clear search"
                    />
                  </InputAdornment>
                ) : null,
              },
            }}
          />

          <DroneList searchName={searchName.trim()} />
        </ArcStack>
      </ArcBaseSidebar>
      <ArcBaseContent>
        <SectionWrapper>
          <DroneHeader />
          <PanelWrapper>
            <ArcTabPanel value='1'> 
              <OrderHistoryPanel /> 
            </ArcTabPanel>
            <ArcTabPanel value='2'>
              <MaintenancePanel />
            </ArcTabPanel>
          </PanelWrapper>
        </SectionWrapper>
      </ArcBaseContent>
    </ArcStack>
  );
};

export default DronesPage;